import { inject } from "@angular/core";
import {
  HttpInterceptorFn,
  HttpRequest,
} from "@angular/common/http";
import { of } from "rxjs";
import { switchMap, catchError, timeout } from "rxjs/operators";
import { CalAngularService } from "@cvx/cal-angular";
import { environment } from "../../environments/environment";

function getScopes(): string[] {
  return [environment.clientId + "/user_impersonation"];
}

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  // Skip token injection for local assets and relative URLs
  if (req.url.startsWith('assets/') || req.url.startsWith('/assets/') || !req.url.startsWith('http')) {
    return next(req);
  }

  const calService = inject(CalAngularService);
  const resource = new URL(req.url).hostname;
  const account = calService.getAccount();

  let claims: string | undefined;

  if (account) {
    const key = `cc.${environment.clientId}.${account.idTokenClaims?.oid}.${resource}`;
    const storedClaims = sessionStorage.getItem(key);

    if (storedClaims) {
      claims = window.atob(storedClaims);
    }
  }

  const scopes = getScopes();

  console.debug('TokenInterceptor: requesting token for', scopes);

  return calService.getAADToken(scopes, false).pipe(
    timeout(10000),
    catchError((err) => {
      console.error('TokenInterceptor: getAADToken failed or timed out', err);
      // Fallback to no token so request can proceed (some APIs may allow anonymous in dev)
      return of("");
    }),
    switchMap((result) => {
      let token = "";

      if (typeof result === "string") {
        token = result;
      } else if (result && typeof result === 'object' && 'accessToken' in result) {
        token = (result as any).accessToken;
      }

      let headers = req.headers

      if (token) {
        headers = headers.set("Authorization", `Bearer ${token}`);
      } else {
        console.warn('TokenInterceptor: proceeding without Authorization header');
      }

      return next(req.clone({ headers }));
    })
  );
};
